import { Symptom } from 'types/symptom';
import darkBlue from './colors/darkBlue';
import grey from './colors/grey';
import royalBlue from './colors/royalBlue';

export const symptomColor: Record<Required<Symptom>['severity'], { backgroundColor: string; textColor: string }> = {
    mild: {
        backgroundColor: grey[600],
        textColor: '#202C3C'
    },
    moderate: {
        backgroundColor: grey[700],
        textColor: '#FFFFFF'
    },
    severe: {
        backgroundColor: darkBlue,
        textColor: '#FFFFFF'
    },
    very_severe: {
        backgroundColor: royalBlue[800],
        textColor: '#FFFFFF'
    }
};
